import { createApp } from 'vue'
import EventArchiveFavaoriteButtton from '../components/event_archive_favorite_button'
import dataPropsParser from '../data_props_parser'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('vue_archive_favorite_button')

  Array.prototype.forEach.call(elements, element => {
    const dataProps = dataPropsParser(element.dataset.props)
    const app = createApp(EventArchiveFavaoriteButtton, dataProps)
    app.mount(`#${element.id}`)
  })
})
